import { Box, Button } from "@mui/material"
import React, { FC } from "react"
import { IUrlButtonData } from "."

interface IUrlButtonProps {
  data: IUrlButtonData
  /** v2: неинтерактивное превью — без href, tabIndex -1, aria-hidden, без иконки (§7). */
  nonInteractive?: boolean
}

const getButtonColor = (
  style?: string,
): "primary" | "success" | "error" | "inherit" => {
  switch (style) {
    case "primary":
      return "primary"
    case "success":
      return "success"
    case "danger":
      return "error"
    default:
      return "inherit"
  }
}

const UrlButton: FC<IUrlButtonProps> = (props) => {
  if (props.nonInteractive) {
    const color = getButtonColor(props.data.style)
    return (
      <Box
        component="span"
        aria-hidden
        tabIndex={-1}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          px: 1.5,
          py: 0.75,
          border: "1px solid",
          borderRadius: 1,
          borderColor: color === "inherit" ? "grey.500" : `${color}.main`,
          color: color === "inherit" ? "text.primary" : `${color}.main`,
        }}
      >
        {props.data.text}
      </Box>
    )
  }

  return (
    <Button
      href={props.data.url}
      variant="outlined"
      fullWidth
      color={getButtonColor(props.data.style)}
    >
      {props.data.icon_custom_emoji_id &&
        `[${props.data.icon_custom_emoji_id}] `}
      {props.data.text}
    </Button>
  )
}

export default UrlButton
